import React, { useCallback, useState } from "react";
import { useSelector } from "react-redux";
import ReactModal from "react-modal";

import { permissionsAccess } from "../../../helpers/common";
import { CLIENT_FIELDS, FIELD_TITLES } from "./ServiceInformation/constants";
import { HookForm, passParamsThrough } from "../../../validation/HForm";
import FormElementsAdd from "./FormElementsAdd";
import EditIcon from "../../../assets/icons/edit.svg";
import CrossIcon from "../../../assets/icons/cross.svg";

const FieldCard = ({ title, content, onEdit }) => {
  const hasEditPermission = permissionsAccess("action.client.update.profile");

  return (
    <div className='content-card'>
      <div className="content-card-title">
        <h3>{title}</h3>
        {hasEditPermission && (
          <div className="content-card-title-actions">
            <button
              className="button-icontrigger caption noborder"
              onClick={() => onEdit(title)}
            >
              <span className="icon">
                <EditIcon />
              </span>
              <span>Редактировать</span>
            </button>
          </div>
        )}
      </div>
      {content && (
        <div className="content-card-content client-card">
          <div className="form-row">
            <div className="form-row-item">
              <div className="form-element">
                <div className="form-element-data form-element-data-text__full">
                  <p>{content}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const EditModal = ({ isOpen, onClose, title, currentField, client, scheme, onSubmit }) => (
  <ReactModal
    isOpen={isOpen}
    className="modal-container"
    overlayClassName="modal-overlay"
  >
    <HookForm onSubmit={onSubmit} validationSchema={scheme}>
      <div className="modal-header">
        <h2>Редактировать {title.toLowerCase()}</h2>
        <button
          className="button-icontrigger modal-closetrigger"
          onClick={onClose}
        >
          <span className="icon">
            <CrossIcon />
          </span>
        </button>
      </div>
      <div className="modal-body">
        <FormElementsAdd h="true" description={client} currentField={currentField} />
      </div>
      <div className="modal-footer">
        <button type="submit" className="button">
          Сохранить
        </button>
        <button type="button" className="button-light" onClick={onClose}>
          Отменить
        </button>
      </div>
    </HookForm>
  </ReactModal>
);

export const FormFieldsView = (props) => {
  const { client, scheme, handleSubmitClientOther, currentField } = props;
  const { accessFeatures } = useSelector(({ user }) => user);
  const [modalState, setModalState] = useState({
    isOpen: false,
    currentField: "",
  });
  const aimAndRelationshipFeature = accessFeatures['client.aim_and_relationship']
  const isCurrentField = Object.keys(FIELD_TITLES).find(key => key === currentField)

  const handleEditField = useCallback((field) => {
    setModalState({
      isOpen: true,
      currentField: field,
    });
  }, []);

  const handleCloseModal = useCallback(() => {
    setModalState({
      isOpen: false,
      currentField: "",
    });
  }, []);

  return passParamsThrough(
    <>
      {Boolean(isCurrentField) ? (
        <FieldCard
          title={isCurrentField === CLIENT_FIELDS.OTHER_INFORMATION && aimAndRelationshipFeature ? `${FIELD_TITLES[currentField]} (служебная информация)` : FIELD_TITLES[currentField]}
          currentField={currentField}
          content={client[currentField]}
          onEdit={handleEditField}
        />
      ) : (
        <>
          <FieldCard
            title={FIELD_TITLES.lackIdentifierDataReason}
            content={client.lackIdentifierDataReason}
            onEdit={handleEditField}
          />
          <FieldCard
            title={FIELD_TITLES.otherInformation}
            content={client.otherInformation}
            onEdit={handleEditField}
          />
        </>
      )}
      <EditModal
        isOpen={modalState.isOpen}
        onClose={handleCloseModal}
        title={modalState.currentField}
        currentField={isCurrentField}
        client={client}
        scheme={scheme}
        onSubmit={handleSubmitClientOther}
      />
    </>,
    props
  );
};
